exports = module.exports = require("../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-bf09d6c0],textarea[data-v-bf09d6c0]{border-style:solid}.v-icon.v-icon[data-v-bf09d6c0]{font-size:14px!important}.token_password_toggle[data-v-bf09d6c0]{position:absolute;margin-top:-30px;right:35px}.gravatar-pic[data-v-bf09d6c0]{border-radius:50%;width:100px;display:initial;margin-bottom:6px}.rg-pic-wrapper .rg-pic-uploader-wrapper[data-v-bf09d6c0]{display:none}.rg-pic-wrapper:hover .rg-pic-uploader-wrapper[data-v-bf09d6c0]{display:block}@media screen and (max-width:500px){.flxmtten[data-v-bf09d6c0]{margin-top:-15px!important}}", ""]);

// exports
